<template>
    <v-dialog
        v-model="dialog"
        :fullscreen="fullscreen"
        :max-width="maxWidth"
        :transition="transition"
        :overlay="!fullscreen"
        scrollable
    >
        <template v-slot:activator="{ on }">
            <v-btn icon fab dark small :color="mode.color" v-on="on">
                <v-icon>{{ mode.icon }}</v-icon>
            </v-btn>
        </template>
        <v-card>
            <v-toolbar card dark color="primary">
                <v-btn icon @click.native="toggleDialog" dark>
                    <v-icon>close</v-icon>
                </v-btn>
                <v-toolbar-title>{{ mode.action }} Categoria</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-toolbar-items>
                    <v-btn dark flat @click.native="save" :disabled="$v.$invalid || saving" :loading="saving">Salvar</v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-container grid-list-md>
                    <v-layout wrap>
                        <v-flex xs8>
                            <v-text-field
                                label="Orbiter # *"
                                v-model="objCategoria.orbiter_id"
                                :error-messages="orbiterIdErrors"
                                @input="$v.objCategoria.orbiter_id.$touch()"
                                @blur="$v.objCategoria.orbiter_id.$touch()"
                                required
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs2>
                            <v-switch label="Ativa" v-model="objCategoria.ativa"></v-switch>
                        </v-flex>
                        <v-flex xs2>
                            <v-switch label="Positivo" v-model="objCategoria.positivo"></v-switch>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                label="Nome da categoria *"
                                v-model="objCategoria.nome"
                                :error-messages="nomeErrors"
                                @input="$v.objCategoria.nome.$touch()"
                                @blur="$v.objCategoria.nome.$touch()"
                                required
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-container>
                <small>* Campos obrigatórios</small>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState        } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required        } from 'vuelidate/lib/validators';
import Util                from '@/util';
import modalMixin          from '@/mixins/modalMixin';

export default {
    name        : 'CategoriasModal',
    mixins      : [modalMixin, validationMixin],
    validations : {
        objCategoria : {
            orbiter_id : {
                required
            },
            nome       : {
                required
            }
        }
    },
    props       : {
        categoria  : {
            type    : Object,
            default : function () {
                return {
                    orbiter_id : '',
                    nome       : '',
                    positivo   : true,
                    ativa      : true
                }
            },
        },
        reloadGrid : Function
    },
    methods     : {
        setObjCategoria() {
            if (this.categoria._id) {
                this.objCategoria = JSON.parse(JSON.stringify(this.categoria));
            } else {
                this.resetObjCategoria();
            }
            // console.log('setObjCategoria', this.objCategoria);
        },
        resetObjCategoria() {
            this.objCategoria = {
                orbiter_id : '',
                nome       : '',
                positivo   : true,
                ativa      : true
            };
        },
        save() {
            this.saving = true;
            const id = (this.objCategoria._id ? `/${this.objCategoria._id}` : '');
            this.$axios[this.mode.method](`categorias${id}`, this.objCategoria).then(response => {
                this.toggleDialog();
                // this.resetObjCategoria();
                this.reloadGrid();
                window.getApp.snackbar = {
                    show  : true,
                    color : 'green',
                    text  : this.mode.snack
                };
            }).catch(error => {
                const errorMsg = Util.getErrorMsg(error.response.data);
                console.error(errorMsg.detailedMsg);
                // this.toggleDialog();
                window.getApp.snackbar = {
                    show      : true,
                    color     : 'red',
                    text      : errorMsg.msg
                };
            }).finally(() => {
                this.saving = false;
            });
        }
    },
    computed    : {
        ...mapState(['user']),
        orbiterIdErrors () {
            const errors = []
            if (!this.$v.objCategoria.orbiter_id.$dirty) {
                return errors;
            }
            !this.$v.objCategoria.orbiter_id.required && errors.push('O campo Orbiter # é obrigatório.');
            return errors;
        },
        nomeErrors () {
            const errors = []
            if (!this.$v.objCategoria.nome.$dirty) {
                return errors;
            }
            !this.$v.objCategoria.nome.required && errors.push('O campo Nome da Categoria é obrigatório.');
            return errors;
        },
        id() {
            return this.objCategoria._id;
        },
    },
    data() {
        return {
            objCategoria : {}
        };
    },
    mounted() {
        this.setObjCategoria();
    },
    watch: {
        dialog(novo, antigo) {
            if (novo) {
                this.setObjCategoria();
            }
        }
    }
};
</script>
